import styled, { css } from 'styled-components';
import { ColorPalette } from 'theme/colors';

const monthDayActive = css`
  max-width: 48px;
  border-radius: 100%;
  ${({ theme }) => `
    color: ${theme.monthPicker.monthDayActiveColor};
    background: ${theme.monthPicker.monthDayActiveBackground};
  `}
`;

export const Month: any = styled.div`
  padding: 16px;
`;

Month.Week = styled.ol`
  display: flex;

  &:first-child,
  &:last-child {
    padding: 0 0;
  }
`;

Month.Week.Day = styled.li`
  text-align: center;
  position: relative;
  text-align: center;
  user-select: none;
  width: 100%;

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 100%;
    height: 48px;
    min-width: 48px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    color: ${({ theme }) => theme.monthPicker.dayColor};

    &:empty {
      cursor: initial;
    }
  }

  &.active > span {
    ${monthDayActive}
  }

  &.active-initial:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    z-index: -1;
    background-color: ${({ theme }) => `${theme.monthPicker.monthRangeDay}`};
  }

  &.active-final:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    z-index: -1;
    background-color: ${({ theme }) => `${theme.monthPicker.monthRangeDay}`};
  }

  &.in-range > span {
    ${({ theme }) => `
      color: ${theme.monthPicker.inRange};
      background-color: ${theme.monthPicker.monthRangeDay};
    `}
  }

  &.outdated > span {
    color: ${({ theme }) => theme.monthPicker.outdated};
    cursor: initial;
  }

  &.today > span {
    color: ${({ theme }) => theme.monthPicker.inRange};
  }

  &.active {
    &.active-initial {
      background: linear-gradient(
        90deg,
        rgba(${ColorPalette.RGB.Black}, 0) 0%,
        rgba(${ColorPalette.RGB.Black}, 0) 49%,
        rgba(${ColorPalette.RGB.Linen}, 1) 51%
      );
    }

    &.active-final {
      background: linear-gradient(
        270deg,
        rgba(${ColorPalette.RGB.Black}, 0) 0%,
        rgba(${ColorPalette.RGB.Black}, 0) 49%,
        rgba(${ColorPalette.RGB.Linen}, 1) 51%
      );
    }
  }
`;
